export default "__VITE_ASSET__CcF0gceD__"